import { useTranslation } from 'react-i18next';
import {
  API_DELETE,
  API_PATCH,
  API_POST,
  DBRequest,
  useConfig,
} from '../../api/api';
import ExoForm from '../exo/ExoForm';
import { useState } from 'react';
import * as Yup from 'yup';
import { tokens } from '../../global/theme/tokens';
import { Box, IconButton, Typography, useTheme } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import DeleteIcon from '@mui/icons-material/Delete';
import ExoAlert from '../exo/ExoAlert';

export const NewSalesObject = ({
  onUpdate,
  onCreate,
  startData,
  onClose,
  onFeedback,
}) => {
  const { t } = useTranslation();
  const config = useConfig();
  const [isLoading, setIsLoading] = useState(false);

  const [reqDel, setReqDel] = useState(null);
  const navigate = useNavigate();
  const theme = useTheme();
  const colors = tokens(theme.palette.mode, theme.palette.colorTheme);

  const fields = [
    {
      label: t('Title Image'),
      type: 'image',
      key: 'image',
    },
    {
      label: t('Title'),
      type: 'text',
      key: 'title',
    },
    {
      label: `${t('Prefix')} (${t('optional')})`,
      type: 'text',
      key: 'prefix',
    },
    {
      label: t('Preset'),
      type: 'salesObjectPreset',
      key: 'preset',
    },
    {
      label: t('show in customer catalog'),
      type: 'checkbox',
      key: 'showInCatalogue',
    },
    {
      label: t('Object supervisor'),
      type: 'user',
      key: 'supervisor',
    },
    {
      label: t('Owner'),
      type: 'client',
      key: 'owner',
    },
  ];

  const validationSchema = Yup.object().shape({
    title: Yup.string().required(t('Is required')),
    supervisor: Yup.object().shape({
      id: Yup.string().required(t('Is required')),
    }),
  });

  function handleSubmit(data) {
    const isUpdate = Boolean(data.id);
    DBRequest({
      config,
      path: isUpdate ? `sales-objects/${data.id}` : `sales-objects`,
      method: isUpdate ? API_PATCH(data) : API_POST(data),
      onResponse: isUpdate ? onUpdate : onCreate,
      onLoading: setIsLoading,
    });
  }

  function handleDelete(element) {
    DBRequest({
      config,
      path: `sales-objects/${element.id}`,
      method: API_DELETE,
      onResponse: navigate(`/sales-objects`),
      onFeedback,
    });
  }

  return (
    <>
      <Box
        className="flex flex-col w-full gap-2"
        sx={{
          '& .delButton': {
            transition: '0.3s ease',
            bgcolor: colors.error + '30',
            color: colors.error,
            border: `1px solid ${colors.error}80`,
            opacity: 1,
            transform: 'translate(0px)',
          },
          ':hover': {
            '& .editButton, & .delButton': {
              opacity: 1,
              transform: 'translate(0px)',
            },
          },
        }}
      >
        <Box
          className="flex items-center justify-between w-full"
          sx={{
            position: 'relative',
          }}
        >
          <Typography
            variant="h3"
            className="py-2"
            sx={(theme) => ({
              textAlign: 'center',
              width: '100%',
            })}
          >
            {startData?.id
              ? t('Update Sales Object')
              : t('Create Sales Object')}
          </Typography>

          {/* delete button - only show when editing lead*/}
          {startData && startData.id && (
            <IconButton
              onClick={() => setReqDel(startData)}
              size="small"
              className="delButton"
              sx={{
                position: 'absolute',
                right: 0,
                top: '20%',
                transform: 'translateY(-50%)',
              }}
            >
              <DeleteIcon sx={{ fontSize: '18px' }} />
            </IconButton>
          )}
        </Box>

        <ExoForm
          fields={fields}
          startDataCollection={
            startData || { status: 0, ownerType: 'internal' }
          }
          onSubmit={handleSubmit}
          onCancel={onClose}
          isLoading={isLoading}
          validationSchema={validationSchema}
          noDifferences
        />

        <ExoAlert
          onSubmit={() => handleDelete(reqDel)}
          open={Boolean(reqDel)}
          onClose={() => setReqDel(null)}
          alert={{
            submitLabel: t('Delete'),
            message: t(
              `Are you sure you want to permanently delete this Sales Object (${startData?.title})?`
            ),
          }}
        />
      </Box>
    </>
  );
};
